import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { DeliveryAddressService } from '@checkout/feature';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { ModalService } from '@spartacus/storefront';
import { SdvorDeliveryAddressDialogModalComponent } from '../delivery-address-dialog/delivery-address-dialog-modal/delivery-address-dialog-modal.component';

@Component({
  selector: 'sd-delivery-add-address',
  templateUrl: './delivery-add-address.component.html',
  styleUrls: ['./delivery-add-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddAddressComponent {
  @Input() text: string;

  iconType = CUSTOM_ICON_TYPE;

  @ViewChild('errorTooltip', { static: false })
  errorTooltip: NgbTooltip | undefined;

  constructor(
    private modalService: ModalService,
    private deliveryAddressService: DeliveryAddressService,
  ) {}

  openModal(): void {
    this.deliveryAddressService.editableAddressId$.next(undefined);

    this.modalService.open(SdvorDeliveryAddressDialogModalComponent, {
      centered: true,
      size: 'xl',
    });
  }
}
